module.exports = __webpack_public_path__ + "static/media/vertisoft.9fa01eff.png";